<ol class="breadcrumb">
  <li>
    <a routerLink="/home">
      <i class="icon-home"></i> Home</a>
  </li>
  <li>{{selectedOption}}</li>
</ol>
<h1>
  {{selectedOption}}
</h1>
<a href="https://cers.aa.com/#/reporthistory/myreports" target="_blank">Click here if a report you submitted is
  not listed.</a>
<br>
<p>CERS is transitioning websites. Not all report types are viewable here.</p>
<p class="note">* Click on the report id to view details</p>

<div class="row">
  <div class="col-lg-12">
    <app-table-my-reports [employeeId]=employeeId>My reports
    </app-table-my-reports>
  </div>
</div>
